import React, { FC } from "react";

const AboutUsSection: FC = () => {
    return (
        <section className="about" id="about">
            <div className="about__info">
                <div className="about__info-title">
                    <h3>Про нас</h3>
                </div>
                <div className="about__info-subtitle">
                    <p>
                        CrossGYM - це провідний фітнес-центр, що пропонує понад 1500 кв. м
                        простору з найсучаснішими тренажерами від провідних
                        брендів, таких як Hammer Strength, Life Fitness та
                        TechnoGym.<br/><br/>Завдяки доступним абонементам, CrossGYM доступний
                        для всіх, хто хоче досягти своїх фітнес-цілей, будь то
                        розвиток сили, підвищення витривалості або схуднення.
                        <br/><br/>Сертифіковані тренери CrossGYM надають кваліфіковані
                        консультації та підтримку для розробки індивідуальних
                        планів тренувань, адаптованих до потреб і цілей кожного.
                    </p>
                </div>
            </div>
            <div className="about__image">
                <img src="../../assets/about.webp" alt="gym" />
            </div>
        </section>
    );
};

export default AboutUsSection;
